<script>
// Ikonica iz mdi fonta zadate veličine u pikselima: <k2-icon n="mdi-pause" :s="18" />
export default {
  name: "K2Icon",
  functional: true,
  props: {
    n: { type: String, required: true },
    s: { type: [Number, String], default: 20 },
  },
  render(h, { props, data }) {
    const size = props.s + "px";
    return h("i", {
      class: ["mdi", props.n, data.class, data.staticClass],
      style: [{ fontSize: size, width: size, height: size }, data.style, data.staticStyle],
      attrs: { "aria-hidden": "true" },
    });
  },
};
</script>
